export const launchNotification = (vue, error, { group = 'error', type = 'error' } = {}) => {
  const errorsObj = error.response.data.errors;
  const title = error.response.data.message;

  Object.values(errorsObj).forEach(errorArray => {
    errorArray.forEach(e => {
      vue.$notify({
        group,
        type,
        title,
        text: e,
      });
    });
  });
};
